export default __webpack_public_path__ + "static/tools-1a36555734c5b4df72f5f53ffd01651f.png";